// extracted by mini-css-extract-plugin
module.exports = {"cardbox":"PublicDetail_cardbox__Jze_k","topbar":"PublicDetail_topbar__H0yPQ","h1":"PublicDetail_h1__Ji7E2","badge":"PublicDetail_badge__zGr6l"};